var map = {
	"./en.png": 1937,
	"./es.png": 4004,
	"./fr.png": 5532,
	"./logo.png": 3153,
	"./security.webp": 3463,
	"./spain.png": 3765,
	"./style.css": 2171,
	"./tally-theme.css": 5150,
	"./téléchargement.jpeg": 9137,
	"./united-kingdom.png": 965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;